import { ListUniversitiesUseCase } from './list_universities.usecase';
import { CreateUniversityUseCase } from './create_university.usecase';
import { UpdateUniversityUseCase } from './update_university.usecase';
import { GetUniversityByIdUseCase } from './get_university_by_id.usecase';

/**
 * University Service
 * Provides access to all university-related use cases
 */
export class UniversityService {
    constructor(
        private readonly listUniversitiesUseCase: ListUniversitiesUseCase,
        private readonly createUniversityUseCase: CreateUniversityUseCase,
        private readonly updateUniversityUseCase: UpdateUniversityUseCase,
        private readonly getUniversityByIdUseCase: GetUniversityByIdUseCase
    ) { }

    async listUniversities(skip?: number, limit?: number) {
        return this.listUniversitiesUseCase.execute(skip, limit);
    }

    async createUniversity(data: any) {
        return this.createUniversityUseCase.execute(data);
    }

    async updateUniversity(data: any) {
        return this.updateUniversityUseCase.execute(data);
    }

    async getUniversityById(id: string) {
        return this.getUniversityByIdUseCase.execute(id);
    }
}